import { Injectable } from '@angular/core';

import { Api, User  } from '../';

@Injectable()
export class Assignment {

  constructor(public api: Api, public user:User) { }

  get(params?: any) {
    return this.api.get('index.php/asset/assignment/', params);
  }

  save(params?: any) {
    return this.api.post('index.php/asset/assignment/', params);
  }

  getAssignee(params?: any){
    return this.api.get('index.php/asset/assignment/assignee', params);
  }

  getAsset(params?: any){
    return this.api.get('index.php/asset/assignment/asset', params);
  }

  getItem(params?: any){
    return this.api.get('index.php/asset/assignment/item', params);
  }

  saveResult(params?: any){
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }else{
      params.created_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/asset/assignment/result', params);
  }

  get_result(params?: any){
    return this.api.get('index.php/asset/assignment/result', params);
  }

  saveTrackAssign(params?: any){
    params.created_by = this.user.data.employee_id;
    return this.api.post('index.php/asset/assignment/trackAssign', params);
  }

  finish_assign(params?: any){
    return this.api.post('index.php/asset/assignment/setStatusAssign', params);
  }

  get_detail(params?:any){
    return this.api.get('index.php/asset/assignment/detailItem', params);
  }

  removeAkses(params?:any){
    return this.api.post('index.php/asset/assignment/akses', params);
  }
  removeItem(params?:any){
    return this.api.post('index.php/asset/assignment/assignmentRemove', params);
  }

  getImages(params?: any) {
    return this.api.get('index.php/asset/assignment/images', params);
  }

  image_post(params?: any){
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }
    // else{
    //   params.created_by = this.user.data.employee_id;
    // }
    return this.api.post('index.php/asset/assignment/image', params);
  }

  addToAssignmentList(params?: any){
    params.updated_by = this.user.data.employee_id;
    return this.api.post('index.php/asset/assignment/addItemAssignment', params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/asset/assignment/assignment.ts